import * as types from './mutation-types';
import api from '../../../../../configurations/service';

export const setDiscountConfiguration = async (context) => {
  const { data } = await api().get('application.get-configuration');
  const {
    hasPercentageDiscountInPdv,
    percentageDiscountInPdv,
    hasPercentageDiscountInNfe,
    percentageDiscountInNfe,
    hasPercentageDiscountInDavs,
    percentageDiscountInDavs,
  } = data.fiscal.emissor;

  const discountConfig = {
    nfcePdv: {
      hasPercentage: hasPercentageDiscountInPdv,
      percentage: percentageDiscountInPdv,
    },
    nfe: {
      hasPercentage: hasPercentageDiscountInNfe,
      percentage: percentageDiscountInNfe,
    },
    davs: {
      hasPercentage: hasPercentageDiscountInDavs,
      percentage: percentageDiscountInDavs,
    },
  };

  context.commit(types.SET_DISCOUNT_CONFIGURATION, discountConfig);
};
